@for (segment of segments; track $index) {
  @if (segment.matched) {
    <mark>{{ segment.text }}</mark>
  } @else {
    <ng-container>{{ segment.text }}</ng-container>
  }
}
